var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M10 2L9 3H3v2h18V3h-6l-1-1h-4zM4.3457 7l1.754 15h11.7636l1.791-15H4.3457zM9 9h2v10H9V9zm4 0h2v10h-2V9z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }